var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUkrainianFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6H20V11C20 11.5523 19.5523 12 19 12H1C0.447715 12 0 11.5523 0 11V6Z",
    fill: "#FFD500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1C0 0.447715 0.447715 0 1 0H19C19.5523 0 20 0.447715 20 1V6H0V1Z",
    fill: "#005BBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkrainianFlag);
export default __webpack_public_path__ + "static/media/UkrainianFlag.79fd0e744b39e78782945104f2e7d04e.svg";
export { ForwardRef as ReactComponent };